exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".app-main{flex:auto;padding:1rem}@media only screen and (min-width:720px){.app-main{display:flex}}", ""]);

